import { render } from "./ModalAddPersonInCharge.vue?vue&type=template&id=008281d4&scoped=true"
import script from "./ModalAddPersonInCharge.vue?vue&type=script&lang=js"
export * from "./ModalAddPersonInCharge.vue?vue&type=script&lang=js"

import "./styles/ModalAddPersonInCharge.scss?vue&type=style&index=0&id=008281d4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008281d4"]])

export default __exports__